import { render, staticRenderFns } from "./realEstateDevelopmentMaintenance.vue?vue&type=template&id=05dbf364&scoped=true"
import script from "./realEstateDevelopmentMaintenance.vue?vue&type=script&lang=js"
export * from "./realEstateDevelopmentMaintenance.vue?vue&type=script&lang=js"
import style0 from "./realEstateDevelopmentMaintenance.vue?vue&type=style&index=0&id=05dbf364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dbf364",
  null
  
)

export default component.exports